import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-account-master',
  templateUrl: './search-account-master.component.html',
  styleUrls: ['./search-account-master.component.scss']
})
export class SearchAccountMasterComponent implements OnInit {

  searchAccountmaster:any;
  arraylist:any=[];
  orignaldata:any =[];
  constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<SearchAccountMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.orignaldata = data;
    this.arraylist = data;
   }

  ngOnInit(): void {

  }
   onAccSearch(searchTerm: string) {
  const lowerSearchTerm = searchTerm.toLowerCase();
  if (!lowerSearchTerm) {
    this.arraylist = this.orignaldata;
    return;
  }
  const exactMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (item.accountCode && item.accountCode.toLowerCase() === lowerSearchTerm)||
      (item.accountHeadName && item.accountHeadName.toLowerCase() === lowerSearchTerm)||
      (item.accountName && item.accountName.toLowerCase() === lowerSearchTerm)||
      (item.accountType && item.accountType.toLowerCase() === lowerSearchTerm)
    );

  const partialMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (
        (item.accountCode && item.accountCode.toLowerCase().includes(lowerSearchTerm)) || 
        (item.accountHeadName && item.accountHeadName.toLowerCase().includes(lowerSearchTerm)) ||
        (item.accountName && item.accountName.toLowerCase().includes(lowerSearchTerm)) ||
        (item.accountType && item.accountType.toLowerCase().includes(lowerSearchTerm))

      ) &&
      !exactMatches.find(m => m._originalIndex === item._originalIndex)
    );

  // const filteredData = [...exactMatches, ...partialMatches];

  this.arraylist = [...exactMatches, ...partialMatches];// assign filtered data back
}

  closedialog() {
    this.dialogRef.close(0);
  }
  selectRowdata(rowdata){
    this.dialogRef.close(rowdata);
  }
}
